import { isToday } from 'date-fns';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import dateToHumanFormat from '@sdk/utils/dateFormat/dateToHumanFormat';

export const getUpcomingShiftStartDateString = ({
  upcomingShiftStartDate,
  usTimeFormat,
}: {
  upcomingShiftStartDate: Date;
  usTimeFormat: boolean;
}) => {
  return isToday(upcomingShiftStartDate)
    ? formatTime(upcomingShiftStartDate, usTimeFormat)
    : `${formatTime(upcomingShiftStartDate, usTimeFormat)} ${dateToHumanFormat(
        upcomingShiftStartDate,
        false
      )}`;
};
